module.exports = __webpack_public_path__ + "img/city.be8eecaa.jpg";